<template>
  <div class="post-survey">
    <div class="header  header-content">
      <v-card class="mx-auto">
        <v-card-title primary-title class="card-title">
          <div style="display: flex;">
            <v-img
              class="title-icon-img"
              cover 
              :src="postSurveyView.titleIconLink"
            ></v-img>
            <span class="md-title">{{ postSurveyView.title }}</span>
          </div>
        </v-card-title>
      </v-card>
    </div>
    <div class="content">
      <v-card class="mx-auto" style="overflow-y: auto;">
        <v-card-text>
          <v-card class="elevation-16 mx-auto" width="100%">
            <v-card-text
              :key="q.QuestionID"
              v-for="q in postSurveyViewCloned.qnas"
            >
              <SurveyQna @onStartRate="rateStarted = true" :data="q" />
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-space-between">
              <v-btn text v-if="isShowSkipBtn" @click="onSkipSurvey">{{
                postSurveyView.skipLabel
              }}</v-btn>
              <v-progress-linear
                v-if="onRequestPending"
                :indeterminate="true"
              ></v-progress-linear>
              <v-btn
                v-if="!onRequestPending"
                :disabled="!rateStarted"
                color="primary"
                text
                @click="onSendSurvey"
              >
                {{ postSurveyView.sendSurveyLabel }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SurveyQna from "../components/SurveyQna";
import Utils from "../helpers/utils";
export default {
  name: "PostSurvey",
  data() {
    return {
      onRequestPending: false,
      isShowSkipBtn: true,
      rateStarted: false,
    };
  },
  components: { SurveyQna },
  created() {
    Utils.log.debug("PostSurveyView created");
    //Clone data, in order to not change state externally
    this.postSurveyViewCloned = JSON.parse(JSON.stringify(this.postSurveyView));
    this.isShowSkipBtn = this.postSurveyView.isShowSkipBtn;
    if (this.widgetData.config.externalController == true) 
      window.parent.postMessage({CC:{"visible":true, "source":this.postSurveyView.title ?? "Survey"}}, "*");
  },
  methods: {
    onSendSurvey() {
      this.isShowSkipBtn = false;
      // We are only in CC for the survey - use the passed call ID
      if (this.$store.state.isSurveyOnly && this.$store.getters.passedCallID && !this.$store.getters.chatData.callId)
        this.$store.commit("setCallId", this.$store.getters.passedCallID);
        //this.$store.getters.chatData.callId = this.$store.getters.passedCallID;

      this.onRequestPending = true;
      this.$store
        .dispatch("sendPostSurvey", this.postSurveyViewCloned.qnas)
        .then(() => {
          this.onRequestPending = false;
          this.$router.push("AfterView");
        })
        .catch((e) => {
          this.onRequestPending = false;
          //in case of errror, show skip button, even if not in config.
          this.isShowSkipBtn = true;
        });
    },
    onSkipSurvey() {
      this.$router.push("AfterView");
    },
  },
  computed: {
    ...mapGetters([
      "appData",
      "widgetData",
      "postSurveyView",
      "conversationView",
      // ...
    ]),
  },
};
</script>

<style scoped>
.title-icon-img {
  padding-right: 5px;
  max-width: 30px;
  display: inline-block;
  margin-right: 10px;
  place-self: center;
  opacity: 0.5;
}
/* .post-survey {
  height: 100%;
  overflow-y: auto;
} */

.post-survey {
  width: 100%;
  height: 100%;
  background-color: #F5F8FC;
  overflow-y: auto;
}
.post-survey > .header {
  height: 65px;
}

.post-survey > .header > .header-content {
  box-shadow: 0px 12px 20px 0px rgba(0,0,0,.1);
  background-color: #ffffff;
  border-radius: 0;
}

.post-survey > .content {
  height: calc(100% - 65px);
  overflow-y: auto;
}

.post-survey > .content > div {
  background: transparent;
  height: 100%;
  box-shadow: none;
}
</style>
